"use strict";


/*! Global scope initializations -------------------------------------------------- */
let html_tag = document.documentElement;
let root_styles = html_tag;
let top_id = document.querySelector('.shopify-section-header');
let nav_top_id = document.querySelector('#nav-top');
let header_outer = document.querySelector('#header-outer');
let header_inner = document.querySelector('#header-inner');
let header_id = header_outer ? header_outer.querySelector('#header') : null;
let search_id = document.querySelector('#search');
let nav_outer = document.querySelector('#nav-outer');
let nav_bar_id = document.querySelector('#nav-bar');
let nav_id = document.querySelector('#nav');
let nav_main = nav_bar_id ?? nav_id;
let content_id = document.getElementById('content');

let viewportWidth = window.innerWidth;
const mediaMax1000 = window.matchMedia('(max-width: 1000px)');
const mediaMin1000 = window.matchMedia('(min-width: 1001px)');

const asyncOnce = {
	once: true
};
const asyncPass = {
	passive: true,
	once: true
};

html_tag.classList.add('js');




/*! Environment & feature detection -------------------------------------------------- */

// Returns a filepath from window.filepaths by key, or falls back to the local path.
const fp = (localPath, key) => (window.filepaths && window.filepaths[key]) || localPath;

// Fallback for pages where custom.js runs before scripts.js exposes js-cookie.
if (typeof window.Cookies === 'undefined') {
	window.Cookies = {
		get(name) {
			const encodedName = `${encodeURIComponent(name)}=`;
			const match = document.cookie.split('; ').find(row => row.startsWith(encodedName));
			return match ? decodeURIComponent(match.slice(encodedName.length)) : undefined;
		},
		set(name, value, options = {}) {
			let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${options.path || '/'}`;
			if (typeof options.expires === 'number') {
				cookie += `; max-age=${options.expires * 24 * 60 * 60}`;
			}
			if (options.sameSite) {
				cookie += `; SameSite=${options.sameSite}`;
			}
			if (options.secure) {
				cookie += '; Secure';
			}
			document.cookie = cookie;
		},
		remove(name, options = {}) {
			document.cookie = `${encodeURIComponent(name)}=; path=${options.path || '/'}; max-age=0`;
		}
	};
}


// Input capability detection (media queries + touch points).
const hoverFinePointerMQ = window.matchMedia('(hover: hover) and (pointer: fine)');
const coarsePointerMQ = window.matchMedia('(pointer: coarse)');
const touchPoints = navigator.maxTouchPoints || navigator.msMaxTouchPoints || 0;

const applyInputCapability = () => {
	const isTouchCapable = coarsePointerMQ.matches || touchPoints > 0 || 'ontouchstart' in window;
	const isHoverCapable = hoverFinePointerMQ.matches;

	html_tag.classList.toggle('is-touch-capable', isTouchCapable);
	html_tag.classList.toggle('is-hover-capable', isHoverCapable);
	html_tag.classList.toggle('no-hover-capable', !isHoverCapable);
};

applyInputCapability();

if (typeof hoverFinePointerMQ.addEventListener === 'function') {
	hoverFinePointerMQ.addEventListener('change', applyInputCapability);
	coarsePointerMQ.addEventListener('change', applyInputCapability);
} else {
	hoverFinePointerMQ.addListener(applyInputCapability);
	coarsePointerMQ.addListener(applyInputCapability);
}

const isMobile = mediaMax1000.matches;
const getViewportWidth = () => window.innerWidth || document.documentElement.clientWidth || viewportWidth;
const getViewportHeight = () => window.innerHeight || parseInt(root_styles.style.getPropertyValue('--app-height-stable'), 10) || 0;

let latestViewportResizeMeta = {
	width: window.innerWidth,
	height: window.innerHeight,
	widthChanged: false,
	heightChanged: false,
	isMobileChromeResize: false
};

const syncStableViewportSize = () => {
	const liveViewportWidth = getViewportWidth();
	const liveViewportHeight = getViewportHeight();
	root_styles.style.setProperty('--app-height-stable', `${liveViewportHeight}px`);
	root_styles.style.setProperty('--app-width-stable', `${liveViewportWidth}px`);
};

const shouldSkipScrollResizeWork = () => latestViewportResizeMeta.isMobileChromeResize;
window.getViewportWidthLive = getViewportWidth;
window.getViewportHeightLive = getViewportHeight;

syncStableViewportSize();
window.addEventListener('pageshow', syncStableViewportSize, { passive: true });
window.addEventListener('orientationchange', () => {
	window.requestAnimationFrame(syncStableViewportSize);
}, { passive: true });
window.addEventListener('resize', () => {
	const width = getViewportWidth();
	const height = getViewportHeight();
	const widthChanged = Math.abs(width - latestViewportResizeMeta.width) > 2;
	const heightChanged = Math.abs(height - latestViewportResizeMeta.height) > 2;
	viewportWidth = width;

	latestViewportResizeMeta = {
		width,
		height,
		widthChanged,
		heightChanged,
		isMobileChromeResize: mediaMax1000.matches && !widthChanged && heightChanged
	};

	if (!latestViewportResizeMeta.isMobileChromeResize) {
		syncStableViewportSize();
	}
}, { passive: true });

// Product "Buy Now": add selected variant to cart and jump straight to checkout.
document.addEventListener('click', async (event) => {
	const buyNowButton = event.target.closest('[data-buy-now-direct]');
	if (!buyNowButton) return;

	event.preventDefault();

	if (buyNowButton.disabled || buyNowButton.classList.contains('processing')) return;

	const form = buyNowButton.closest('form');
	if (!form) return;

	buyNowButton.disabled = true;
	buyNowButton.classList.add('processing');

	try {
		const formData = new FormData(form);
		const variantId = form.querySelector('.product-variant-id');

		if (!formData.get('id') && variantId) {
			formData.set('id', variantId.value);
		}

		const response = await fetch('/cart/add.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: { Accept: 'application/json' },
			body: formData
		});

		if (!response.ok) {
			throw new Error('Buy Now add failed');
		}

		window.location.href = '/checkout';
	} catch (error) {
		buyNowButton.disabled = false;
		buyNowButton.classList.remove('processing');
	}
});

// Product page quantity controls: keep sticky/main in sync, and make sticky CTA
// clicks submit the current quantity instead of a stale mirrored value.

const findProductQtyControls = () => ({
	main:
		document.querySelector('#main-product [data-product-qty-select]') ||
		document.querySelector('#main-product .f8pr-amount select[name="quantity"], #main-product .f8pr-amount input[name="quantity"]'),
	sticky:
		document.querySelector('#sticky-add-to-cart [data-sticky-qty-select]') ||
		document.querySelector('#sticky-add-to-cart select#product_qty_sticky, #sticky-add-to-cart input#product_qty_sticky')
});

const getQtyControlValue = (control) => {
	if (!control) return '';
	return String(control.value || '').trim();
};

const setQtyControlValue = (control, nextValue) => {
	if (!control) return false;

	const tagName = control.tagName ? control.tagName.toUpperCase() : '';
	if (tagName === 'SELECT') {
		const nextValueString = String(nextValue || '').trim();
		const matchingOption = Array.from(control.options).find(
			(option) => !option.disabled && option.value === nextValueString
		);
		if (!matchingOption) return false;
		control.value = matchingOption.value;
		return true;
	}

	const min = parseFloat(control.getAttribute('min')) || 1;
	const maxAttr = parseFloat(control.getAttribute('max'));
	const max = Number.isFinite(maxAttr) ? maxAttr : Infinity;
	const parsedValue = parseFloat(nextValue);
	const safeValue = Number.isFinite(parsedValue) ? parsedValue : min;
	control.value = String(Math.max(min, Math.min(max, safeValue)));
	return true;
};

const syncProductQtyControls = ({ source, target, dispatchTargetChange = false } = {}) => {
	if (!source || !target) return;

	const sourceValue = getQtyControlValue(source);
	if (!sourceValue) return;

	const updated = setQtyControlValue(target, sourceValue);
	if (updated && dispatchTargetChange) {
		target.dispatchEvent(new Event('change', { bubbles: true }));
	}
};

const bindProductQtyControl = (control, onChange) => {
	if (!control || control.dataset.qtySyncListening === 'true') return;

	control.dataset.qtySyncListening = 'true';
	control.addEventListener('change', onChange);

	if (control.tagName && control.tagName.toUpperCase() !== 'SELECT') {
		control.addEventListener('input', onChange);
	}
};

const initProductQtyControls = () => {
	if (!document.body || !document.body.classList.contains('template-product')) return;

	const { main, sticky } = findProductQtyControls();
	if (!main && !sticky) return;

	if (main && sticky) {
		syncProductQtyControls({ source: main, target: sticky });
	}

	bindProductQtyControl(main, () => {
		const controls = findProductQtyControls();
		syncProductQtyControls({ source: controls.main, target: controls.sticky });
	});

	bindProductQtyControl(sticky, () => {
		const controls = findProductQtyControls();
		syncProductQtyControls({ source: controls.sticky, target: controls.main });
	});
};

document.addEventListener('click', (event) => {
	const stickySubmitButton = event.target.closest('#sticky-add-to-cart button[form]');
	if (!stickySubmitButton) return;

	const { main, sticky } = findProductQtyControls();
	syncProductQtyControls({ source: sticky, target: main });
});

initProductQtyControls();
document.addEventListener('DOMContentLoaded', () => {
	initProductQtyControls();
});
window.addEventListener('pageshow', initProductQtyControls);
window.addEventListener('productVariants', initProductQtyControls);

// Collection/search list-view qty select: keep this one native instead of the theme BVSelect replacement.
const forceNativeCollectionListQtySelect = (scope = document) => {
	const root = scope && scope.querySelectorAll ? scope : document;
	const qtySelects = root.matches && root.matches('.collection-list-qty-select')
		? [root]
		: Array.from(root.querySelectorAll('.collection-list-qty-select'));

	qtySelects.forEach((select) => {
		const fakeSelect = select.nextElementSibling;
		if (fakeSelect && fakeSelect.classList.contains('bv_mainselect')) {
			fakeSelect.remove();
		}

		select.classList.remove('hidden', 'select-init', 'semantic-select-initialized');
		select.removeAttribute('data-random');
		select.removeAttribute('tabindex');
		select.removeAttribute('aria-hidden');
		select.style.display = '';
		select.style.visibility = '';
		select.style.opacity = '';
	});
};

// Collection/search sort select: prevent repeated BVSelect initialization from stacking duplicate dropdowns.
const COLLECTION_SORT_NATIVE_SELECTOR = '.collection-sort-select[name="sort_by"], .f8sr-sort select[name="sort_by"], #sort_by';

const forceNativeCollectionSortSelect = (scope = document) => {
	const root = scope && scope.querySelectorAll ? scope : document;
	const sortSelects = root.matches && root.matches(COLLECTION_SORT_NATIVE_SELECTOR)
		? [root]
		: Array.from(root.querySelectorAll(COLLECTION_SORT_NATIVE_SELECTOR));

	sortSelects.forEach((select) => {
		const parent = select.parentElement;
		if (parent) {
			Array.from(parent.children).forEach((node) => {
				if (node.classList && node.classList.contains('bv_mainselect')) {
					node.remove();
				}
			});
		}

		select.classList.remove('hidden', 'select-init', 'semantic-select-initialized');
		select.removeAttribute('data-random');
		select.removeAttribute('tabindex');
		select.removeAttribute('aria-hidden');
		select.style.display = '';
		select.style.visibility = '';
		select.style.opacity = '';
	});
};

// Related/recently-viewed/product-page rails: keep visible variant pickers native.
const PRODUCT_CARD_NATIVE_VARIANT_SELECTOR = [
	'#section-related .product-card .collection-variant-row select[name="id"]',
	'.recently-viewed-products .product-card .collection-variant-row select[name="id"]',
	'.l4cl.product-page-native-scroll .product-card .collection-variant-row select[name="id"]'
].join(', ');

const forceNativeProductCardVariantSelects = (scope = document) => {
	const root = scope && scope.querySelectorAll ? scope : document;
	const variantSelects = root.matches && root.matches(PRODUCT_CARD_NATIVE_VARIANT_SELECTOR)
		? [root]
		: Array.from(root.querySelectorAll(PRODUCT_CARD_NATIVE_VARIANT_SELECTOR));

	variantSelects.forEach((select) => {
		const fakeSelect = select.nextElementSibling;
		if (fakeSelect && fakeSelect.classList.contains('bv_mainselect')) {
			fakeSelect.remove();
		}

		const parent = select.parentElement;
		if (parent) {
			Array.from(parent.children).forEach((node) => {
				if (node.classList && node.classList.contains('bv_mainselect')) {
					node.remove();
				}
			});
		}

		select.classList.remove('hidden', 'select-init', 'semantic-select-initialized');
		select.removeAttribute('data-random');
		select.removeAttribute('tabindex');
		select.removeAttribute('aria-hidden');
		select.style.display = '';
		select.style.visibility = '';
		select.style.opacity = '';
	});
};

forceNativeCollectionListQtySelect();
forceNativeCollectionSortSelect();
forceNativeProductCardVariantSelects();
document.addEventListener('DOMContentLoaded', () => {
	forceNativeCollectionListQtySelect(document);
	forceNativeCollectionSortSelect(document);
	forceNativeProductCardVariantSelects(document);
});
document.addEventListener('shopify:section:load', (event) => {
	forceNativeCollectionListQtySelect(event.target);
	forceNativeCollectionSortSelect(event.target);
	forceNativeProductCardVariantSelects(event.target);
});
window.addEventListener('semanticSelect', () => {
	window.requestAnimationFrame(() => initProductQtyControls());
	window.requestAnimationFrame(() => forceNativeCollectionListQtySelect(document));
	window.requestAnimationFrame(() => forceNativeCollectionSortSelect(document));
	window.requestAnimationFrame(() => forceNativeProductCardVariantSelects(document));
});
window.addEventListener('collectionSort', () => {
	window.requestAnimationFrame(() => forceNativeCollectionSortSelect(document));
});
window.addEventListener('pageshow', () => {
	forceNativeCollectionSortSelect(document);
});

// Product inline description: show read-more only when preview is truncated.
// Prefer sentence-end (period) trimming, then fallback to break-based trimming.
const INLINE_DESC_ORIGINAL_HTML_KEY = 'inlineDescOriginalHtml';
const INLINE_DESC_MIN_LINES = 8;
const INLINE_DESC_TARGET_LINES = 8;
const INLINE_DESC_MAX_LINES = 8;
const INLINE_DESC_BREAK_SELECTOR = 'br, ul, ol, p, li, blockquote, h1, h2, h3, h4, h5, h6';

const restoreInlineDescriptionPreview = (preview) => {
	if (!preview.dataset[INLINE_DESC_ORIGINAL_HTML_KEY]) {
		preview.dataset[INLINE_DESC_ORIGINAL_HTML_KEY] = preview.innerHTML;
		return;
	}
	if (preview.innerHTML !== preview.dataset[INLINE_DESC_ORIGINAL_HTML_KEY]) {
		preview.innerHTML = preview.dataset[INLINE_DESC_ORIGINAL_HTML_KEY];
	}
};

const getInlineDescriptionThresholdHeight = (preview) => {
	const lineHeight = parseFloat(window.getComputedStyle(preview).lineHeight);
	if (!Number.isFinite(lineHeight) || lineHeight <= 0) return 0;
	return lineHeight;
};

const getInlineDescriptionBreakCandidates = (preview) => {
	const candidates = [];
	preview.querySelectorAll(INLINE_DESC_BREAK_SELECTOR).forEach((node) => {
		if (node.tagName === 'BR') {
			candidates.push(node);
			return;
		}
		if (node.tagName === 'UL' || node.tagName === 'OL') {
			candidates.push(node);
			return;
		}
		if (node.tagName === 'LI') {
			candidates.push(node);
			return;
		}
		if (node.textContent && node.textContent.trim()) {
			candidates.push(node);
		}
	});
	return candidates;
};

const cleanupInlineDescriptionTail = (preview) => {
	const isEmptyElement = (el) => {
		if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
		if (el.matches('br')) return true;
		if (el.querySelector('img,svg,video,iframe,table,ul,ol,li')) return false;
		return !el.textContent || !el.textContent.trim();
	};

	while (preview.lastChild) {
		if (preview.lastChild.nodeType === Node.TEXT_NODE && !preview.lastChild.textContent.trim()) {
			preview.removeChild(preview.lastChild);
			continue;
		}
		if (preview.lastChild.nodeType === Node.ELEMENT_NODE && preview.lastChild.tagName === 'BR') {
			preview.removeChild(preview.lastChild);
			continue;
		}
		if (isEmptyElement(preview.lastChild)) {
			preview.removeChild(preview.lastChild);
			continue;
		}
		break;
	}
};

const getInlineDescriptionPeriodCandidates = (preview) => {
	const candidates = [];
	const walker = document.createTreeWalker(preview, NodeFilter.SHOW_TEXT, {
		acceptNode: (node) => (node.textContent && node.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT)
	});

	let textNode = walker.nextNode();
	while (textNode) {
		const value = textNode.textContent || '';
		const periodRegex = /\./g;
		let match = periodRegex.exec(value);
		while (match) {
			const previousChar = value[match.index - 1] || '';
			if (/\S/.test(previousChar)) {
				candidates.push({
					node: textNode,
					offset: match.index + 1
				});
			}
			match = periodRegex.exec(value);
		}
		textNode = walker.nextNode();
	}

	return candidates;
};

const trimInlineDescriptionToPeriod = (preview, maxHeight) => {
	const periodCandidates = getInlineDescriptionPeriodCandidates(preview);
	if (!periodCandidates.length) return false;

	const previewRect = preview.getBoundingClientRect();
	let chosenCandidate = null;

	periodCandidates.forEach((candidate) => {
		const rangeToCandidate = document.createRange();
		rangeToCandidate.setStart(preview, 0);
		rangeToCandidate.setEnd(candidate.node, candidate.offset);

		const rects = rangeToCandidate.getClientRects();
		if (!rects.length) return;

		const lastRect = rects[rects.length - 1];
		const relativeBottom = lastRect.bottom - previewRect.top;
		if (relativeBottom <= maxHeight + 1) {
			chosenCandidate = candidate;
		}
	});

	if (!chosenCandidate) return false;

	const previousHTML = preview.innerHTML;
	const rangeAfterPeriod = document.createRange();
	rangeAfterPeriod.setStart(chosenCandidate.node, chosenCandidate.offset);
	rangeAfterPeriod.setEnd(preview, preview.childNodes.length);
	rangeAfterPeriod.deleteContents();

	cleanupInlineDescriptionTail(preview);
	return preview.innerHTML !== previousHTML;
};

const trimInlineDescriptionToBreak = (preview, minHeight, targetHeight, maxHeight) => {
	const breaks = getInlineDescriptionBreakCandidates(preview);
	if (!breaks.length) return false;

	const previewRect = preview.getBoundingClientRect();
	const measuredBreaks = [];
	let previousTextLength = 0;

	breaks.forEach((lineBreak) => {
		const rangeToBreak = document.createRange();
		rangeToBreak.setStart(preview, 0);
		if (lineBreak.tagName === 'UL' || lineBreak.tagName === 'OL') {
			rangeToBreak.setEndBefore(lineBreak);
		} else {
			rangeToBreak.setEndAfter(lineBreak);
		}
		const rects = rangeToBreak.getClientRects();
		if (!rects.length) return;

		const textLength = rangeToBreak
			.toString()
			.replace(/\s+/g, ' ')
			.trim().length;
		const isMeaningfulBreak = textLength > previousTextLength;
		previousTextLength = Math.max(previousTextLength, textLength);

		const lastRect = rects[rects.length - 1];
		const relativeBottom = lastRect.bottom - previewRect.top;
		measuredBreaks.push({
			node: lineBreak,
			bottom: relativeBottom,
			deltaToTarget: Math.abs(relativeBottom - targetHeight),
			meaningful: isMeaningfulBreak
		});
	});

	if (!measuredBreaks.length) return false;

	const inRangeMeaningful = measuredBreaks
		.filter((item) => item.meaningful && item.bottom >= minHeight - 1 && item.bottom <= maxHeight + 1)
		.sort((a, b) => a.deltaToTarget - b.deltaToTarget);

	const belowMaxMeaningful = measuredBreaks
		.filter((item) => item.meaningful && item.bottom <= maxHeight + 1)
		.sort((a, b) => a.deltaToTarget - b.deltaToTarget);

	const inRangeAny = measuredBreaks
		.filter((item) => item.bottom >= minHeight - 1 && item.bottom <= maxHeight + 1)
		.sort((a, b) => a.deltaToTarget - b.deltaToTarget);

	const belowMaxAny = measuredBreaks
		.filter((item) => item.bottom <= maxHeight + 1)
		.sort((a, b) => a.deltaToTarget - b.deltaToTarget);

	const chosenBreak =
		(inRangeMeaningful[0] && inRangeMeaningful[0].node) ||
		(belowMaxMeaningful[0] && belowMaxMeaningful[0].node) ||
		(inRangeAny[0] && inRangeAny[0].node) ||
		(belowMaxAny[0] && belowMaxAny[0].node);

	if (!chosenBreak) return false;
	const previousHTML = preview.innerHTML;
	const rangeAfterBreak = document.createRange();
	if (chosenBreak.tagName === 'UL' || chosenBreak.tagName === 'OL') {
		rangeAfterBreak.setStartBefore(chosenBreak);
	} else {
		rangeAfterBreak.setStartAfter(chosenBreak);
	}
	rangeAfterBreak.setEnd(preview, preview.childNodes.length);
	rangeAfterBreak.deleteContents();

	// Remove trailing empty nodes left after trimming so no fake blank space remains.
	cleanupInlineDescriptionTail(preview);

	return preview.innerHTML !== previousHTML;
};

const syncInlineDescriptionTruncation = (scope = document) => {
	const blocks = scope.querySelectorAll('#main-product .f8pr-inline-description');
	blocks.forEach((block) => {
		const preview = block.querySelector('.f8pr-inline-description__preview');
		if (!preview) return;

		restoreInlineDescriptionPreview(preview);
		cleanupInlineDescriptionTail(preview);

		const lineHeight = getInlineDescriptionThresholdHeight(preview);
		if (lineHeight <= 0) {
			block.classList.remove('is-truncated');
			return;
		}

		const maxHeight = lineHeight * INLINE_DESC_MAX_LINES;
		const minHeight = lineHeight * INLINE_DESC_MIN_LINES;
		const targetHeight = lineHeight * INLINE_DESC_TARGET_LINES;
		const isOverflowing = preview.scrollHeight > maxHeight + 2;

		if (!isOverflowing) {
			block.classList.remove('is-truncated');
			return;
		}

		const trimmedToPeriod = trimInlineDescriptionToPeriod(preview, maxHeight);

		if (!trimmedToPeriod || preview.scrollHeight > maxHeight + 2) {
			trimInlineDescriptionToBreak(preview, minHeight, targetHeight, maxHeight);
		}

		block.classList.add('is-truncated');
	});
};

const resetInlineDescriptionTruncationState = (scope = document) => {
	const previews = scope.querySelectorAll('#main-product .f8pr-inline-description__preview');
	previews.forEach((preview) => {
		delete preview.dataset[INLINE_DESC_ORIGINAL_HTML_KEY];
	});
	scope.querySelectorAll('#main-product .f8pr-inline-description').forEach((block) => {
		block.classList.remove('is-truncated');
	});
};

let inlineDescriptionSyncTimer = null;
let inlineDescriptionSyncFrame = 0;
const scheduleInlineDescriptionSync = () => {
	if (inlineDescriptionSyncTimer) {
		window.clearTimeout(inlineDescriptionSyncTimer);
		inlineDescriptionSyncTimer = null;
	}
	if (inlineDescriptionSyncFrame) {
		window.cancelAnimationFrame(inlineDescriptionSyncFrame);
		inlineDescriptionSyncFrame = 0;
	}

	// Variant updates can patch DOM asynchronously; wait one frame + a short delay.
	inlineDescriptionSyncFrame = window.requestAnimationFrame(() => {
		inlineDescriptionSyncTimer = window.setTimeout(() => {
			syncInlineDescriptionTruncation();
			inlineDescriptionSyncTimer = null;
			inlineDescriptionSyncFrame = 0;
		}, 60);
	});
};

document.addEventListener('DOMContentLoaded', () => {
	syncInlineDescriptionTruncation();
});

window.addEventListener('resize', () => {
	if (shouldSkipScrollResizeWork()) return;
	syncInlineDescriptionTruncation();
}, { passive: true });

document.addEventListener('shopify:section:load', (event) => {
	syncInlineDescriptionTruncation(event.target);
});

const SKU_PILL_COLOR_RULES = [
	{ contains: "-FN", label: "FN", backgroundColor: "#FF7F27", textColor: "#111111" },
	{ contains: "-MC", label: "MC", backgroundColor: "#e7d000", textColor: "#111111" },
	{ contains: "ZN-T", label: "T", backgroundColor: "#919191", textColor: "#111111" },
	{ contains: "-TFE", label: "T", backgroundColor: "#919191", textColor: "#111111" },
	{ contains: "T-SET", label: "T", backgroundColor: "#919191", textColor: "#111111" },
	{ contains: "ZN-P", label: "P", backgroundColor: "#000000", textColor: "#ffffff" },
	{ contains: "-PFE", label: "P", backgroundColor: "#000000", textColor: "#ffffff" },
	{ contains: "P-SET", label: "P", backgroundColor: "#000000", textColor: "#ffffff" },
	{ contains: "-IAW", label: "IAW", backgroundColor: "#09b1ff", textColor: "#111111" },
];

const getSkuPillData = (skuRaw) => {
	if (!skuRaw) return null;
	const sku = String(skuRaw).toUpperCase();
	const match = SKU_PILL_COLOR_RULES.find((rule) => sku.includes(rule.contains));
	return match || null;
};

const normalizeCollectionCardSku = (skuRaw) => {
	const sku = String(skuRaw || '').replace(/^A2Z-?/i, '').trim();
	return sku;
};

const normalizeVariantTitle = (value) => {
	const title = String(value || '').replace(/\s+/g, ' ').trim();
	if (!title) return '';
	if (title.toLowerCase() === 'default title') return '';
	return title;
};

const buildTitleWithVariant = (baseTitle, variantTitle) => {
	const base = String(baseTitle || '').replace(/\s+/g, ' ').trim();
	const variant = normalizeVariantTitle(variantTitle);
	if (!base) return variant;
	return variant ? `${base} - ${variant}` : base;
};

const getMainProductSelectedVariantTitle = (productRoot) => {
	if (!productRoot) return '';

	const variantSelect = productRoot.querySelector('.f8pr-variant-selection select[name="variant-id"]');
	if (variantSelect && variantSelect.options.length) {
		const selectedOption = variantSelect.options[variantSelect.selectedIndex];
		if (selectedOption) {
			return normalizeVariantTitle(selectedOption.textContent);
		}
	}

	const checkedVariantRadio = productRoot.querySelector('.f8pr-variant-selection input[type="radio"][name="variant-id"]:checked');
	if (checkedVariantRadio) {
		return normalizeVariantTitle(checkedVariantRadio.getAttribute('title') || checkedVariantRadio.value);
	}

	const selectedOptionValues = [];
	productRoot.querySelectorAll('.f8pr-variant-selection select[name^="options"]').forEach((select) => {
		const selected = select.options[select.selectedIndex];
		if (selected) {
			const value = normalizeVariantTitle(selected.textContent);
			if (value) selectedOptionValues.push(value);
		}
	});

	productRoot.querySelectorAll('.f8pr-variant-selection input[type="radio"][name^="options"]:checked').forEach((radio) => {
		const value = normalizeVariantTitle(radio.getAttribute('title') || radio.value);
		if (value) selectedOptionValues.push(value);
	});

	if (!selectedOptionValues.length) {
		productRoot.querySelectorAll('.f8pr-variant-selection input[type="radio"][name^="color"]:checked').forEach((radio) => {
			const value = normalizeVariantTitle(radio.getAttribute('title') || radio.value);
			if (value) selectedOptionValues.push(value);
		});
	}

	return normalizeVariantTitle(selectedOptionValues.join(' / '));
};

const getMainProductSelectedVariantId = (productRoot) => {
	if (!productRoot) return '';

	const variantSelect = productRoot.querySelector('.f8pr-variant-selection select[name="variant-id"]');
	if (variantSelect && variantSelect.value) return variantSelect.value;

	const checkedVariantRadio = productRoot.querySelector('.f8pr-variant-selection input[type="radio"][name="variant-id"]:checked');
	return checkedVariantRadio ? checkedVariantRadio.value : '';
};

const syncMainProductPaymentTerms = (scope = document) => {
	const productRoot = scope instanceof Element && scope.matches('#main-product')
		? scope
		: scope.querySelector?.('#main-product');
	if (!productRoot) return;

	const variantId = getMainProductSelectedVariantId(productRoot);
	if (!variantId) return;

	const paymentTermsInput = productRoot.querySelector('.payment-terms-variant-id');
	if (paymentTermsInput && paymentTermsInput.value !== variantId) {
		paymentTermsInput.value = variantId;
		paymentTermsInput.dispatchEvent(new Event('change', { bubbles: true }));
	}

	productRoot.querySelectorAll('shopify-payment-terms').forEach((paymentTerms) => {
		paymentTerms.setAttribute('variant-id', variantId);
	});
};

const syncMainProductVariantTitle = (scope = document) => {
	const productRoots = [];
	if (scope instanceof Element && scope.matches('#main-product')) {
		productRoots.push(scope);
	} else if (scope && scope.querySelectorAll) {
		productRoots.push(...scope.querySelectorAll('#main-product'));
	}
	if (!productRoots.length && scope === document) {
		productRoots.push(...document.querySelectorAll('#main-product'));
	}

	productRoots.forEach((productRoot) => {
		const titleEls = productRoot.querySelectorAll('.js-product-title-with-variant[data-base-title]');
		if (!titleEls.length) return;

		const variantTitle = getMainProductSelectedVariantTitle(productRoot);
		titleEls.forEach((titleEl) => {
			const baseTitle = titleEl.dataset.baseTitle || titleEl.textContent;
			titleEl.textContent = buildTitleWithVariant(baseTitle, variantTitle);
		});
	});
};

// Product-card collection variant dropdown: keep price pill, image and add-to-cart state in sync.
const syncCollectionCardVariantSelection = (select, options = {}) => {
	const { updateImage = true } = options;
	if (!select) return;

	const selectedOption = select.options[select.selectedIndex];
	if (!selectedOption) return;

	let variantData = null;
	try {
		variantData = selectedOption.dataset.variantinfo ? JSON.parse(selectedOption.dataset.variantinfo) : null;
	} catch (error) {
		variantData = null;
	}

	const productCard = select.closest('li.product-card');
	if (!productCard) return;

	const productTitleLink = productCard.querySelector('h3 > a[data-product-title-link][data-base-title]');
	if (productTitleLink) {
		const baseTitle = productTitleLink.dataset.baseTitle || productTitleLink.textContent;
		productTitleLink.textContent = buildTitleWithVariant(baseTitle, selectedOption.textContent);
	}

	const hiddenVariantInput = productCard.querySelector('form.form-card input.collection-variant-id-input[name="id"]');
	if (hiddenVariantInput) {
		hiddenVariantInput.value = selectedOption.value;
		hiddenVariantInput.setAttribute('value', selectedOption.value);
	}

	if (variantData && variantData.price) {
		const priceRow = productCard.querySelector('.price.collection-price-row');
		if (priceRow) {
			const mainPrice = priceRow.querySelector('.collection-price-main');
			const oldPrice = priceRow.querySelector('.collection-price-discount');

			if (mainPrice) {
				mainPrice.dataset.originalPriceText = variantData.price;
				mainPrice.textContent = variantData.price;
			}
			if (oldPrice) {
				if (variantData.price_old) {
					oldPrice.textContent = variantData.price_old;
					oldPrice.classList.remove('hidden');
				} else {
					oldPrice.textContent = '';
					oldPrice.classList.add('hidden');
				}
			}
		}
	}

	if (typeof window.syncListViewPricePresentation === 'function') {
		window.syncListViewPricePresentation(productCard.closest('#collection') || document);
	}

	if (updateImage && variantData && variantData.image) {
		const cardImage = productCard.querySelector('figure img');
		if (cardImage) {
			cardImage.loading = 'lazy';
			cardImage.decoding = 'async';
			cardImage.src = variantData.image;
			cardImage.removeAttribute('srcset');
			cardImage.removeAttribute('sizes');
		}
	}

	const skuValue = productCard.querySelector('[data-collection-card-sku-value]');
	if (skuValue) {
		skuValue.textContent = normalizeCollectionCardSku(variantData && variantData.sku ? variantData.sku : '');
	}

	const skuPill = productCard.querySelector('.sku-material-pill');
	if (skuPill) {
		const skuPillData = getSkuPillData(variantData && variantData.sku ? variantData.sku : '');
		if (skuPillData) {
			skuPill.textContent = skuPillData.label;
			skuPill.setAttribute('data-material', skuPillData.label);
			skuPill.classList.remove('hidden');
		} else {
			skuPill.classList.add('hidden');
		}
	}

	const submitButton = productCard.querySelector('form.form-card .collection-list-cta-control[data-ai-action="add-to-cart"], form.form-card button[type="submit"]');
	if (submitButton) {
		const isUnavailable = selectedOption.disabled || selectedOption.dataset.class === 'disabled';
		submitButton.disabled = isUnavailable;
		const listCtaControl = productCard.querySelector('.collection-list-cta-control[data-ai-action="add-to-cart"]');
		const listBuyNowControl = productCard.querySelector('.collection-list-cta-control[data-ai-action="buy-now"]');
		const listQtySelect = productCard.querySelector('.collection-list-qty-select');
		if (listCtaControl) {
			listCtaControl.disabled = isUnavailable;
			listCtaControl.classList.toggle('is-disabled', isUnavailable);
			listCtaControl.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
			if (listBuyNowControl) {
				listBuyNowControl.disabled = isUnavailable;
				listBuyNowControl.classList.toggle('is-disabled', isUnavailable);
				listBuyNowControl.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
			}
			if (listQtySelect) listQtySelect.disabled = isUnavailable;
		} else {
			submitButton.classList.toggle('overlay-unavailable-buy-button', isUnavailable);
			submitButton.classList.toggle('overlay-buy_button', !isUnavailable);
		}
	}
};

document.addEventListener('change', (event) => {
	const select = event.target.closest('.product-card .collection-variant-row select[name="id"]');
	if (!select) return;
	syncCollectionCardVariantSelection(select, { updateImage: true });
});

document.addEventListener('click', (event) => {
	if (!(event.target instanceof Element)) return;

	const cardBody = event.target.closest('[data-product-card-body-link]');
	if (!cardBody) return;

	const productCard = cardBody.closest('.product-card[data-card-product-url]');
	if (!productCard) return;

	if (event.defaultPrevented || event.button !== 0) return;
	if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
	if (event.target.closest('a, button, input, select, option, textarea, label, form, summary, details, [role="button"], [role="link"]')) {
		return;
	}

	window.location.href = productCard.dataset.cardProductUrl;
});

['pointerdown', 'mousedown', 'touchstart', 'click'].forEach((eventName) => {
	document.addEventListener(eventName, (event) => {
		if (!(event.target instanceof Element)) return;

		const variantControl = event.target.closest(
			'.product-card .collection-variant-row, .product-card .collection-variant-row select, .product-card .collection-variant-row .bv_mainselect'
		);

		if (!variantControl) return;
		event.stopPropagation();
	}, true);
});

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.product-card .collection-variant-row select[name="id"]').forEach((select) => {
		syncCollectionCardVariantSelection(select, { updateImage: false });
	});
});

document.addEventListener('shopify:section:load', (event) => {
	event.target.querySelectorAll('.product-card .collection-variant-row select[name="id"]').forEach((select) => {
		syncCollectionCardVariantSelection(select, { updateImage: false });
	});
});

function setNativePdpGalleryIndex(gallery, nextIndex) {
	if (!gallery) return;

	const panels = Array.from(gallery.querySelectorAll('[data-pdp-gallery-panel]'));
	const thumbs = Array.from(gallery.querySelectorAll('[data-pdp-gallery-index]'));
	if (!panels.length) return;

	const parsedIndex = parseInt(nextIndex, 10);
	if (Number.isNaN(parsedIndex) || parsedIndex < 0 || parsedIndex >= panels.length) return;

	panels.forEach((panel, index) => {
		const isActive = index === parsedIndex;
		panel.classList.toggle('is-active', isActive);
		panel.hidden = !isActive;
		panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
		panel.tabIndex = isActive ? 0 : -1;

		panel.querySelectorAll('video').forEach((video) => {
			if (!isActive && typeof video.pause === 'function') video.pause();
		});
	});

	thumbs.forEach((thumb, index) => {
		const isActive = index === parsedIndex;
		thumb.classList.toggle('is-active', isActive);
		thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
		thumb.tabIndex = isActive ? 0 : -1;
	});

	gallery.dataset.activeIndex = `${parsedIndex}`;

	const activeThumb = thumbs[parsedIndex];
	if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
		activeThumb.scrollIntoView({
			block: 'nearest',
			inline: 'nearest'
		});
	}
}

function getNativePdpGalleryPreferredIndex(gallery) {
	if (!gallery) return 0;

	const galleryRoot = gallery.closest('.m6pr') || document;
	const checkedControl = galleryRoot.querySelector('.f8pr-variant-selection input[data-l4pr-index]:checked');
	if (checkedControl) {
		const checkedIndex = parseInt(checkedControl.dataset.l4prIndex, 10);
		if (!Number.isNaN(checkedIndex) && checkedIndex >= 0) return checkedIndex;
	}

	const variantSelects = galleryRoot.querySelectorAll('.f8pr-variant-selection select');
	for (const select of variantSelects) {
		const option = select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
		if (!option || !option.dataset.l4prIndex) continue;
		const selectedIndex = parseInt(option.dataset.l4prIndex, 10);
		if (!Number.isNaN(selectedIndex) && selectedIndex >= 0) return selectedIndex;
	}

	const initialIndex = parseInt(gallery.dataset.initialIndex || '0', 10);
	return Number.isNaN(initialIndex) || initialIndex < 0 ? 0 : initialIndex;
}

function initNativePdpGallery(scope) {
	const root = scope && scope.querySelector ? scope : document;
	const galleries = root.matches && root.matches('[data-pdp-gallery]')
		? [root]
		: Array.from(root.querySelectorAll('[data-pdp-gallery]'));

	for (const gallery of galleries) {
		if (gallery.dataset.pdpGalleryBound !== '1') {
			gallery.dataset.pdpGalleryBound = '1';
			gallery.addEventListener('click', (event) => {
				const thumb = event.target.closest('[data-pdp-gallery-index]');
				if (!thumb || !gallery.contains(thumb)) return;
				setNativePdpGalleryIndex(gallery, thumb.dataset.pdpGalleryIndex);
			});
			gallery.addEventListener('keydown', (event) => {
				const thumb = event.target.closest('[data-pdp-gallery-index]');
				if (!thumb || !gallery.contains(thumb)) return;

				const thumbs = Array.from(gallery.querySelectorAll('[data-pdp-gallery-index]'));
				if (!thumbs.length) return;

				const currentIndex = thumbs.indexOf(thumb);
				if (currentIndex < 0) return;

				let nextThumb = null;
				switch (event.key) {
					case 'ArrowUp':
					case 'ArrowLeft':
						nextThumb = thumbs[(currentIndex - 1 + thumbs.length) % thumbs.length];
						break;
					case 'ArrowDown':
					case 'ArrowRight':
						nextThumb = thumbs[(currentIndex + 1) % thumbs.length];
						break;
					case 'Home':
						nextThumb = thumbs[0];
						break;
					case 'End':
						nextThumb = thumbs[thumbs.length - 1];
						break;
					default:
						return;
				}

				event.preventDefault();
				if (!nextThumb) return;
				setNativePdpGalleryIndex(gallery, nextThumb.dataset.pdpGalleryIndex);
				nextThumb.focus();
			});
		}

		setNativePdpGalleryIndex(gallery, getNativePdpGalleryPreferredIndex(gallery));
	}
}

function syncNativePdpGalleryFromVariantControl(control) {
	if (!control || !control.dataset) return;
	const nextIndex = parseInt(control.dataset.l4prIndex || '', 10);
	if (Number.isNaN(nextIndex) || nextIndex < 0) return;

	const galleryRoot = control.closest('.m6pr') || document;
	const gallery = galleryRoot.querySelector('[data-pdp-gallery]');
	if (!gallery) return;

	setNativePdpGalleryIndex(gallery, nextIndex);
}

document.addEventListener('change', (event) => {
	if (!(event.target instanceof Element)) return;
	if (!event.target.closest('#main-product .f8pr-variant-selection')) return;

	const control = event.target.matches('select')
		? event.target.options[event.target.selectedIndex]
		: event.target;

	window.requestAnimationFrame(() => {
		if (control) syncNativePdpGalleryFromVariantControl(control);
	});
	window.requestAnimationFrame(() => {
		syncMainProductVariantTitle();
		syncMainProductPaymentTerms();
	});
	scheduleInlineDescriptionSync();
});

document.addEventListener('DOMContentLoaded', () => {
	initNativePdpGallery(document);
	syncMainProductVariantTitle();
	syncMainProductPaymentTerms();
});

document.addEventListener('shopify:section:load', (event) => {
	initNativePdpGallery(event.target);
	syncMainProductVariantTitle(event.target);
	syncMainProductPaymentTerms(event.target);
});

window.addEventListener('productVariants', () => {
	initNativePdpGallery(document);
	window.requestAnimationFrame(() => {
		syncMainProductVariantTitle();
		syncMainProductPaymentTerms();
	});
	scheduleInlineDescriptionSync();
});

const PRODUCT_PAGE_REFRESH_EVENTS = [
	'productVariants',
	'semanticSelect',
	'showHideDataElement',
	'sellingplans',
	'pickupAvailability',
	'modulePanel',
	'modulePanelAnchor',
	'schemeTooltip',
	'popups',
	'removeSDCcss',
	'semanticInput',
	'formZindex',
	'dataChange',
	'ratings',
	'listProductSlider',
	'listDrop',
	'fancybox',
	'rangeSlider',
	'recommendedProducts',
	'accordeon',
	'countdown',
	'moduleTabs',
	'recentlyViewedProducts'
];

const dispatchProductPageRefreshEvents = () => {
	PRODUCT_PAGE_REFRESH_EVENTS.forEach((eventName) => {
		window.dispatchEvent(new CustomEvent(eventName));
	});
};

const switchMainProductToUrl = async ({ nextProductUrl, selectEl, lockElements = [] }) => {
	if (!nextProductUrl) return;

	const mainProduct = document.querySelector('#main-product');
	if (!mainProduct) return;

	const templateId = mainProduct.getAttribute('data-template');
	const productFormSection = templateId ? document.querySelector(`.m6pr-${templateId}`) : null;
	const productForm = productFormSection ? productFormSection.querySelector('form.f8pr') : null;
	const sticky = document.getElementById('sticky-add-to-cart');

	if (productForm) {
		productForm.classList.add('processing');
	}
	if (sticky) {
		sticky.classList.add('processing');
	}
	if (selectEl) {
		selectEl.disabled = true;
	}
	lockElements.forEach((el) => {
		if (el) el.disabled = true;
	});

	try {
		const response = await fetch(nextProductUrl, { credentials: 'same-origin' });
		if (!response.ok) {
			throw new Error(`Request failed: ${response.status}`);
		}

		const text = await response.text();
		const nextDocument = new DOMParser().parseFromString(text, 'text/html');

		const currentTitle = document.querySelector('head title');
		const nextTitle = nextDocument.querySelector('head title');
		if (currentTitle && nextTitle) {
			currentTitle.textContent = nextTitle.textContent;
		}

		const currentContent = document.getElementById('content');
		const nextContent = nextDocument.querySelector('#content');
		if (currentContent && nextContent) {
			currentContent.replaceWith(nextContent);
		}

		const currentVariantEl = nextDocument.querySelector('[data-current-variant]');
		const selectedVariantId = currentVariantEl && currentVariantEl.dataset ? currentVariantEl.dataset.currentVariant : '';
		const nextUrl = new URL(nextProductUrl, window.location.origin);
		if (selectedVariantId && !nextUrl.searchParams.get('variant')) {
			nextUrl.searchParams.set('variant', selectedVariantId);
		}
		const updatedPath = `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
		window.history.replaceState({}, '', updatedPath);

		dispatchProductPageRefreshEvents();
		if (typeof window.ajaxCart !== 'undefined' && window.ajaxCart && typeof window.ajaxCart.init === 'function') {
			window.ajaxCart.init();
		}
		if (typeof window.linkMoreClick === 'function') {
			window.linkMoreClick();
		}
		window.requestAnimationFrame(() => syncMainProductVariantTitle());
	} catch (error) {
		console.warn('Family product switch error', error);
		if (selectEl) {
			selectEl.disabled = false;
		}
		lockElements.forEach((el) => {
			if (el) el.disabled = false;
		});
		if (productForm) {
			productForm.classList.remove('processing');
		}
		if (sticky) {
			sticky.classList.remove('processing');
		}
	}
};

document.addEventListener('change', (event) => {
	if (!(event.target instanceof Element)) return;

	const familySelect = event.target.closest('#main-product .f8pr-family-select');
	if (familySelect) {
		const selectedOption = familySelect.options[familySelect.selectedIndex];
		if (!selectedOption || selectedOption.disabled) return;

		const nextProductUrl = selectedOption.dataset.productUrl || selectedOption.value;
		const currentProductUrl = familySelect.dataset.currentProductUrl;
		if (!nextProductUrl || (currentProductUrl && nextProductUrl === currentProductUrl)) return;

		switchMainProductToUrl({ nextProductUrl, selectEl: familySelect });
		return;
	}

});

// Mobile fallback for tight buttons: if "Add to cart" wraps to 2+ lines, show short label "Add".
const ADD_TO_CART_SHORT_LABEL = 'Add To Cart';
const addToCartShortLabelMQ = window.matchMedia('(max-width: 1000px)');

const supportsAdaptiveAddLabel = () => {
	const body = document.body;
	if (!body) return false;
	return (
		body.classList.contains('template-product')
		|| body.classList.contains('template-collection')
		|| body.classList.contains('template-search')
	);
};

const isElementVisible = (el) => {
	if (!el) return false;
	const styles = window.getComputedStyle(el);
	return styles.display !== 'none' && styles.visibility !== 'hidden';
};

const getRenderedLineCount = (el) => {
	if (!el || !isElementVisible(el)) return 1;
	const range = document.createRange();
	range.selectNodeContents(el);
	const rects = Array.from(range.getClientRects()).filter((rect) => rect.width > 0 && rect.height > 0);
	if (!rects.length) return 1;

	let lines = 0;
	let lastTop = null;

	rects.forEach((rect) => {
		if (lastTop === null || Math.abs(rect.top - lastTop) > 1) {
			lines += 1;
			lastTop = rect.top;
		}
	});

	return Math.max(lines, 1);
};

const syncAdaptiveAddToCartLabels = (scope = document) => {
	if (!supportsAdaptiveAddLabel()) return;

	const labels = scope.querySelectorAll('button.overlay-buy_button [data-add-to-cart-label]');

	labels.forEach((label) => {
		const button = label.closest('button.overlay-buy_button');
		if (!button) return;

		if (!label.dataset.fullLabel) {
			label.dataset.fullLabel = label.textContent.trim();
		}

		label.textContent = label.dataset.fullLabel;
		button.removeAttribute('data-short-add-label');

		if (!addToCartShortLabelMQ.matches) return;
		if (!isElementVisible(button) || !isElementVisible(label)) return;

		const lineCount = getRenderedLineCount(label);
		if (lineCount > 1) {
			label.textContent = ADD_TO_CART_SHORT_LABEL;
			button.setAttribute('data-short-add-label', 'true');
		}
	});
};

const scheduleAdaptiveAddToCartLabelSync = (() => {
	let rafId = null;
	return (scope = document) => {
		if (rafId !== null) {
			window.cancelAnimationFrame(rafId);
		}
		rafId = window.requestAnimationFrame(() => {
			syncAdaptiveAddToCartLabels(scope);
		});
	};
})();

document.addEventListener('DOMContentLoaded', () => {
	scheduleAdaptiveAddToCartLabelSync();
});

window.addEventListener('resize', () => {
	if (shouldSkipScrollResizeWork()) return;
	scheduleAdaptiveAddToCartLabelSync();
}, { passive: true });

if (typeof addToCartShortLabelMQ.addEventListener === 'function') {
	addToCartShortLabelMQ.addEventListener('change', () => {
		scheduleAdaptiveAddToCartLabelSync();
	});
} else if (typeof addToCartShortLabelMQ.addListener === 'function') {
	addToCartShortLabelMQ.addListener(() => {
		scheduleAdaptiveAddToCartLabelSync();
	});
}

document.addEventListener('shopify:section:load', (event) => {
	scheduleAdaptiveAddToCartLabelSync(event.target);
});

// Checks if the current page is NOT a fully initialized Shopify store.
const isShopify = () => window.Shopify === undefined || Object.keys(window.Shopify).length < 3;


// Checks if Shopify Theme Editor (designMode) is active on this page
const isShopifyDesignMode = () => { return typeof window.Shopify !== 'undefined' && !!window.Shopify.designMode; };


// Checks if :has() pseudo-selector is supported
const isHasSelectorSupported = () => {
	try {
		document.querySelector(':has(*)');
		return true;
	} catch (e) {
		return false;
	}
};


// Sets global text direction based on <html dir> attribute (RTL or LTR).
const global_dir = html_tag.getAttribute('dir') === 'rtl' ? ['rtl', false] : ['ltr', true];


// Returns the current HTML theme if it's in the allowed list.
const getHtmlTheme = (themes = ['xclusive', 'xtra']) => {
	const theme = html_tag.dataset.theme ? html_tag.dataset.theme.toLowerCase() : null;
	return theme && themes.includes(theme) ? theme : null;
};




/*! Helper Functions -------------------------------------------------- */

// Moves all .popup-a elements from #content to be direct children of #root (and keeps doing so for dynamically added popups) to avoid z-index/stacking issues.
const initPopupRootRelocator = (function () {
	if (window.__popupRelocatorInitialized) return;
	window.__popupRelocatorInitialized = true;

	const MOVED_ATTR = 'data-popup-moved';

	function movePopupToRoot(popup, root_id) {
		if (!popup || popup.nodeType !== 1) return;
		if (popup.getAttribute(MOVED_ATTR) === '1') return;

		root_id.appendChild(popup);
		popup.setAttribute(MOVED_ATTR, '1');
	}

	function relocateNow() {
		const root_id = document.getElementById('root') || document.body;

		if (!root_id || !content_id) return false;

		const popups = content_id.querySelectorAll('.popup-a');
		for (let i = 0; i < popups.length; i++) {
			movePopupToRoot(popups[i], root_id);
		}

		if (!window.__popupRelocatorContentObserver && 'MutationObserver' in window) {
			const obs = new MutationObserver(mutations => {
				for (let m = 0; m < mutations.length; m++) {
					const added = mutations[m].addedNodes;
					for (let j = 0; j < added.length; j++) {
						const node = added[j];
						if (!node || node.nodeType !== 1) continue;

						if (node.classList && node.classList.contains('popup-a')) {
							movePopupToRoot(node, root_id);
							continue;
						}

						if (node.querySelectorAll) {
							const nested = node.querySelectorAll('.popup-a');
							for (let k = 0; k < nested.length; k++) {
								movePopupToRoot(nested[k], root_id);
							}
						}
					}
				}
			});

			obs.observe(content_id, {
				childList: true,
				subtree: true
			});
			window.__popupRelocatorContentObserver = obs;
		}

		return true;
	}

	if (relocateNow()) return;

	if ('MutationObserver' in window) {
		const bootObs = new MutationObserver(() => {
			if (relocateNow()) bootObs.disconnect();
		});
		bootObs.observe(document.documentElement, {
			childList: true,
			subtree: true
		});
	} else {
		document.addEventListener('DOMContentLoaded', relocateNow, {
			once: true
		});
	}
})();


// Returns all sibling elements of a given element, excluding the element itself.
const getSiblings = el => el?.parentNode ? [...el.parentNode.children].filter(s => s !== el) : [];


// Appends an <a> element with given content, class, href, and optional accessibility attributes to a target element.
const append_url = (el, content, className, href, access) => {
	if (!el) return;

	const link = createElementWithClass('a', className);
	link.href = href || '#';

	if (access) {
		link.tabIndex = -1;
		link.setAttribute('aria-hidden', 'true');
		link.setAttribute('focusable', 'false');
	}

	link.innerHTML = content;
	el.appendChild(link);
};


// Dynamically adds a CSS <link> to the document if not already present, optionally after existing <link> elements.
function new_css(id, href, media) {
	if (document.getElementById(id)) return;
	const link = document.createElement('link');
	media = media || 'screen';

	link.setAttribute('id', id);
	link.setAttribute('rel', 'stylesheet');
	link.setAttribute('href', href);
	link.setAttribute('media', media);

	const css = document.querySelectorAll('link[id]');
	if (css.length) {
		css[css.length - 1].after(link);
	} else {
		document.head.appendChild(link);
	}
}


// Loads an external JS file and runs a callback when it's loaded.
function loadRes(u, c, i) {
	const loaded = html_tag.classList.contains(i);

	if (loaded) {
		if (typeof c === 'function') c();
		return true;
	}
	const s = document.createElement('script');
	s.src = u;
	s.async = true;
	if (typeof c === 'function') {
		s.onload = c;
	}
	s.onerror = () => console.warn(`Script failed: ${u}`);
	document.body.appendChild(s);

	html_tag.classList.add(i);
}


// Returns a throttled version of a function that executes at most once per specified delay.
function throttle(callback, delay) {
	let timeoutId;
	return function () {
		if (!timeoutId) {
			timeoutId = setTimeout(() => {
				callback();
				timeoutId = null;
			}, delay);
		}
	};
}


// Clones the given element, adds class to the clone, inserts it after the original, and adds class to the original element.
function clone_with_class(el, cl1, cl2) {
	if (!el) return;
	const cln = el.cloneNode(true);
	cln.classList.add(cl1);
	el.after(cln);
	el.classList.add(cl2);
}


// Initializes a Swiper slider on the given element, wrapping children as slides, setting up navigation, pagination, accessibility roles, and handling optional image overlays.
function create_slider(el, settings, minSlides) {
	const imgOverlays = [];
	let bg = false;
	const children = Array.from(el.children);
	const childrenLength = children.length;

	for (let i = 0; i < childrenLength; i++) {
		const child = children[i];
		if (child.classList.contains('img-overlay')) {
			bg = true;
			imgOverlays.push(child);
			child.remove();
		}
	}

	if (childrenLength > 1) {
		if (el.tagName.toLowerCase() === 'ul') {
			const ul = el;

			requestAnimationFrame(() => {
				ul.setAttribute('role', 'none');
				for (let i = 0; i < childrenLength; i++) {
					const li = children[i];
					li.setAttribute('role', 'none');
					li.classList.add('li');
				}
			});
		}

		minSlides = minSlides || 1;

		if (childrenLength > parseFloat(minSlides)) {
			let paginationClass = (settings && settings.pagination && settings.pagination.el) || ".swiper-pagination";
			paginationClass = paginationClass.replace(/\./g, " ").trim();

			const dots = document.createElement('span');
			dots.className = paginationClass;

			const prev = document.createElement('span');
			prev.classList.add('swiper-button-prev', 'swiper-button-nav');

			const next = document.createElement('span');
			next.classList.add('swiper-button-next', 'swiper-button-nav');

			el.classList.add('s4wi');

			requestAnimationFrame(() => {
				prev.setAttribute('role', 'navigation');
				next.setAttribute('role', 'navigation');
			});

			const slidesFragment = document.createDocumentFragment();
			for (let i = 0; i < childrenLength; i++) {
				const child = children[i];
				const wrapper = document.createElement('div');
				wrapper.classList.add('swiper-slide');
				wrapper.appendChild(child);
				slidesFragment.appendChild(wrapper);
			}

			const swiperOuter = document.createElement('div');
			swiperOuter.className = 'swiper-outer';

			const swiperWrapper = document.createElement('div');
			swiperWrapper.className = 'swiper-wrapper';
			swiperWrapper.appendChild(slidesFragment);

			swiperOuter.appendChild(swiperWrapper);

			const swiperFragment = document.createDocumentFragment();
			swiperFragment.appendChild(swiperOuter);

			// Pagination
			const pagination = document.createElement('div');
			pagination.className = 'swiper-custom-pagination';
			swiperFragment.appendChild(pagination);

			if (settings && settings.pagination) {
				settings.pagination.el = settings.pagination.el || pagination;
				pagination.append(prev, dots, createElementWithClass('span', 'swiper-custom-fraction'), next);
			} else {
				const navFragment = document.createDocumentFragment();
				navFragment.append(prev, next);
				swiperFragment.appendChild(navFragment);
			}

			el.appendChild(swiperFragment);


			// Navigation
			settings.navigation = settings.navigation || {};
			settings.navigation.prevEl = prev;
			settings.navigation.nextEl = next;

			const swiperInstance = new Swiper(swiperOuter, settings);

			requestAnimationFrame(() => {
				const paginationBullets = el.querySelectorAll('.swiper-pagination-bullet');
				for (let i = 0; i < paginationBullets.length; i++) {
					paginationBullets[i].setAttribute('role', 'navigation');
				}
			});

			return swiperInstance;
		}
	}
	if (bg) {
		requestAnimationFrame(() => {
			for (let i = 0; i < imgOverlays.length; i++) {
				const imgOverlay = imgOverlays[i];
				el.appendChild(imgOverlay);
			}
		});
	}

	return null;
}


// Assignes random number for better control of slider elements.
function randomize(el) {
	el.setAttribute('data-random', Math.floor(Math.random() * 10000) + 1);
}


// Sets the z-index of each element so the first element is on top and the last is at the bottom
function assignIndex(elements) {
	elements.forEach((el, index) => {
		el.style.zIndex = elements.length - index;
	});
}


// Creates an element of the given tag and applies one or multiple CSS classes.
function createElementWithClass(tag, classList) {
	const el = document.createElement(tag);
	if (!Array.isArray(classList)) classList = [classList];
	el.classList.add(...classList);
	return el;
}


// Schedules the callback to run when the browser is idle (using requestIdleCallback when available, falling back to a short setTimeout).
function runWhenIdle(fn) {
	if ('requestIdleCallback' in window) {
		requestIdleCallback(fn, {
			timeout: 2000
		});
	} else {
		setTimeout(fn, 300);
	}
}


// Loads Swiper runtime on demand so pages without sliders don't parse its payload.
function loadSwiperRuntime(done) {
	const callback = typeof done === 'function' ? done : function () {};
	if (typeof window.Swiper === 'function') {
		callback();
		return;
	}

	const plugin_swiper_js = fp('js/plugin-swiper.js', 'plugin_swiper_js');
	loadRes(plugin_swiper_js, callback, 'plugin-swiper-loaded');
}


// Loads slider runtime only when slider-like DOM is present (or sections are dynamically loaded).
let sliderRuntimeRequested = false;
let sliderRuntimeObserverStarted = false;

function hasSliderCandidates(scope) {
	const root = scope && scope.querySelector ? scope : document;
	return !!root.querySelector('.m6fr:not(.s4wi), .l4ts:not(.s4wi), .l4st:not(.static, .s4wi), .l4us:not(.l4us-initialized), .l4cl, .l4cl.slider:not(.s4wi), .l4ft.slider:not(.s4wi), .l4pr, #collection.l4cl.mobile-scroll:not(.list, .hr), #section-related .l4cl:not(.list, .hr), .recently-viewed-products .l4cl:not(.list, .hr), .l4cl.product-page-native-scroll:not(.list, .hr)');
}

function loadSliderRuntime() {
	if (sliderRuntimeRequested) return;
	sliderRuntimeRequested = true;

	loadSwiperRuntime(() => {
		const custom_sliders_js = fp('js/custom-sliders.js', 'custom_sliders_js');
		loadRes(custom_sliders_js, () => {
			window.dispatchEvent(new CustomEvent('sliderRuntimeReady'));
		}, 'custom-sliders-loaded');
	});
}

// Treat tablets like desktop on the homepage so header/nav and slider setup happen before they can shift the layout.
const isMobileHomeTemplate = !!(document.body && document.body.classList.contains('template-index') && window.matchMedia('(max-width: 760px)').matches);

function scheduleMobileHomeDeferredInit(callback, delay) {
	if (!isMobileHomeTemplate) {
		callback();
		return callback;
	}

	let started = false;
	let loadTimer = null;

	const cleanup = () => {
		window.removeEventListener('pointerdown', start, asyncPass);
		window.removeEventListener('wheel', start, asyncPass);
		document.removeEventListener('touchstart', start, asyncPass);
		document.removeEventListener('keyup', start, asyncOnce);
		window.removeEventListener('load', queueFromLoad);
		if (loadTimer !== null) {
			clearTimeout(loadTimer);
			loadTimer = null;
		}
	};

	const start = () => {
		if (started) return;
		started = true;
		cleanup();
		runWhenIdle(callback);
	};

	const queueFromLoad = () => {
		if (started) return;
		loadTimer = window.setTimeout(start, delay || 900);
	};

	window.addEventListener('pointerdown', start, asyncPass);
	window.addEventListener('wheel', start, asyncPass);
	document.addEventListener('touchstart', start, asyncPass);
	document.addEventListener('keyup', start, asyncOnce);

	if (document.readyState === 'complete') {
		queueFromLoad();
	} else {
		window.addEventListener('load', queueFromLoad, { once: true, passive: true });
	}

	return start;
}

function scheduleSliderRuntimeLoad(scope) {
	if (sliderRuntimeRequested) return;
	const root = scope && scope.querySelector ? scope : document;
	const isHomeTemplate = !!(document.body && document.body.classList.contains('template-index'));

	// Product gallery is above the fold on PDP, so initialize slider runtime immediately.
	// Delaying it by a frame lets the thumbnail rail pop in after first paint and causes CLS.
	if (root.querySelector('#main-product .l4pr:not(.s4wi)')) {
		loadSliderRuntime();
		return;
	}

	// Keep desktop homepage hero interactive immediately, but let mobile paint before loading slider runtime.
	if (isHomeTemplate && !isMobileHomeTemplate && root.querySelector('.m6fr:not(.s4wi)')) {
		requestAnimationFrame(() => setTimeout(loadSliderRuntime, 0));
		return;
	}

	const candidate = root.querySelector('.m6fr:not(.s4wi), .l4ts:not(.s4wi), .l4st:not(.static, .s4wi), .l4us:not(.l4us-initialized), .l4cl, .l4cl.slider:not(.s4wi), .l4ft.slider:not(.s4wi), .l4pr, #collection.l4cl.mobile-scroll:not(.list, .hr), #section-related .l4cl:not(.list, .hr), .recently-viewed-products .l4cl:not(.list, .hr), .l4cl.product-page-native-scroll:not(.list, .hr)');
	if (!candidate) return;

	if (!('IntersectionObserver' in window)) {
		runWhenIdle(loadSliderRuntime);
		return;
	}

	if (sliderRuntimeObserverStarted) return;
	sliderRuntimeObserverStarted = true;

	const loadOnIntent = () => {
		runWhenIdle(loadSliderRuntime);
		window.removeEventListener('pointerdown', loadOnIntent, asyncPass);
		window.removeEventListener('wheel', loadOnIntent, asyncPass);
		document.removeEventListener('touchstart', loadOnIntent, asyncPass);
		document.removeEventListener('keyup', loadOnIntent, asyncOnce);
	};

	const observer = new IntersectionObserver((entries, obs) => {
		for (const entry of entries) {
			if (!entry.isIntersecting) continue;
			obs.disconnect();
			loadOnIntent();
			break;
		}
	}, {
		root: null,
		rootMargin: '450px 0px',
		threshold: 0
	});

	observer.observe(candidate);

	window.addEventListener('pointerdown', loadOnIntent, asyncPass);
	window.addEventListener('wheel', loadOnIntent, asyncPass);
	document.addEventListener('touchstart', loadOnIntent, asyncPass);
	document.addEventListener('keyup', loadOnIntent, asyncOnce);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => scheduleSliderRuntimeLoad(document), { once: true });
} else {
	scheduleSliderRuntimeLoad(document);
}

document.addEventListener('shopify:section:load', (event) => {
	scheduleSliderRuntimeLoad(event && event.target ? event.target : document);
});


// Loads non-critical enhancement runtime after intent/viewport signals.
let enhancementsRuntimeRequested = false;
let enhancementsRuntimeObserverStarted = false;

function loadEnhancementsRuntime() {
	if (enhancementsRuntimeRequested) return;
	enhancementsRuntimeRequested = true;

	const custom_enhancements_js = fp('js/custom-enhancements.js', 'custom_enhancements_js');
	loadRes(custom_enhancements_js, () => {
		window.dispatchEvent(new CustomEvent('enhancementsRuntimeReady'));
	}, 'custom-enhancements-loaded');
}

function hasEnhancementCandidates(scope) {
	const root = scope && scope.querySelector ? scope : document;
	return !!root.querySelector('.m6pn, [class*="input-"][class*="fix"], [data-val][data-of], .media-flexible, [id$="page-service-info-blocks"], .check[data-limit], video.lazy, .f8pr, select, form');
}

function scheduleEnhancementsRuntimeLoad(scope) {
	if (enhancementsRuntimeRequested) return;
	const root = scope && scope.querySelector ? scope : document;
	if (!hasEnhancementCandidates(root)) return;

	const loadOnIntent = () => {
		loadEnhancementsRuntime();
		window.removeEventListener('pointerdown', loadOnIntent, asyncPass);
		window.removeEventListener('wheel', loadOnIntent, asyncPass);
		document.removeEventListener('touchstart', loadOnIntent, asyncPass);
		document.removeEventListener('keyup', loadOnIntent, asyncOnce);
	};

	const candidate = root.querySelector('.m6pn, [data-val][data-of], .media-flexible, .check[data-limit], video.lazy, .f8pr, form');
	if (candidate && 'IntersectionObserver' in window && !enhancementsRuntimeObserverStarted) {
		enhancementsRuntimeObserverStarted = true;
		const observer = new IntersectionObserver((entries, obs) => {
			for (const entry of entries) {
				if (!entry.isIntersecting) continue;
				obs.disconnect();
				loadOnIntent();
				break;
			}
		}, {
			root: null,
			rootMargin: '350px 0px',
			threshold: 0
		});
		observer.observe(candidate);
	}

	window.addEventListener('pointerdown', loadOnIntent, asyncPass);
	window.addEventListener('wheel', loadOnIntent, asyncPass);
	document.addEventListener('touchstart', loadOnIntent, asyncPass);
	document.addEventListener('keyup', loadOnIntent, asyncOnce);
	window.addEventListener('load', () => {
		setTimeout(() => {
			runWhenIdle(loadEnhancementsRuntime);
		}, 1400);
	}, asyncOnce);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => scheduleEnhancementsRuntimeLoad(document), { once: true });
} else {
	scheduleEnhancementsRuntimeLoad(document);
}

document.addEventListener('shopify:section:load', (event) => {
	scheduleEnhancementsRuntimeLoad(event && event.target ? event.target : document);
});


// ensures Swiper sliders update their auto height on load, resize, and when entering viewport, skipping theme editor mode.  
function updateSliders(el) {
	if (!el.classList.contains('s4wi')) return;

	const sl_el = el.querySelector('.swiper-outer');
	if (!sl_el) return;

	function io(entries) {
		for (const entry of entries) {
			if (entry.isIntersecting && sl_el.swiper) {
				sl_el.swiper.updateAutoHeight();
			}
		}
	}

	new IntersectionObserver(io).observe(el);

	setTimeout(() => {
		if (sl_el.swiper) {
			sl_el.swiper.updateAutoHeight();
		}
	}, 300);
}




/*! Layout utilities -------------------------------------------------- */

// Calculates and sets '--sticky_offset' for sticky headers, updating on scroll, resize, or user interaction, with throttling.
let stickyOffsetCalculated = false;
let stickyOffsetScheduled = false;
let stickyListenersAdded = false;

const SO_req = ['.m6pr', '[id^="section-"]', '.f8sr', '.m6cl', '.m6ac'];
const requiredElementsExist = SO_req.some(sel => document.querySelector(sel));

function stickyOffset() {
	if (stickyOffsetScheduled) return;
	stickyOffsetScheduled = true;

	requestAnimationFrame(() => {
		stickyOffsetScheduled = false;

		if (stickyOffsetCalculated || !nav_main || !header_outer || !header_inner) return;
		if (!requiredElementsExist) return;

		const setStickyOffset = () => {
			const h = header_outer.getBoundingClientRect().height;
			html_tag.style.setProperty('--sticky_offset', `${h}px`);
		};

		const setNavMainOffset = () => {
			const h = nav_main.getBoundingClientRect().height;
			html_tag.style.setProperty('--sticky_offset', `${h}px`);
		};

		const updateSticky = () => {
			if (mediaMax1000.matches) {
				setStickyOffset();
			} else if (mediaMin1000.matches) {
				setNavMainOffset();
			}
		};

		if (header_inner.classList.contains('sticky-nav')) {
			html_tag.classList.add('has-sticky-nav');
			updateSticky();

			if (!stickyListenersAdded) {
				mediaMax1000.addEventListener('change', updateSticky);
				mediaMin1000.addEventListener('change', updateSticky);
				stickyListenersAdded = true;
			}
		} else {
			setStickyOffset();
		}

		stickyOffsetCalculated = true;
	});
}

if (!isMobile) {
	window.addEventListener('mousemove', stickyOffset, asyncOnce);
}
window.addEventListener('pointerdown', stickyOffset, asyncPass);
window.addEventListener('wheel', stickyOffset, asyncPass);
document.addEventListener('keyup', stickyOffset, asyncOnce);
document.addEventListener('touchstart', stickyOffset, asyncPass);
window.addEventListener('resize', throttle(() => {
	if (shouldSkipScrollResizeWork()) return;
	stickyOffsetCalculated = false;
	stickyOffset();
}, 500));

// Prevent the mobile PDP header spacer from being inserted on first scroll.
function primeMobileProductHeaderSpacing() {
	if (!document.body || !document.body.classList.contains('template-product')) return;
	if (!window.matchMedia('(max-width: 760px)').matches) return;
	if (!top_id || !header_outer || !header_inner) return;

	requestAnimationFrame(() => {
		const stickyTarget = html_tag.classList.contains('t1sn') && nav_main ? nav_main : header_outer;
		const headerHeight = Math.ceil(header_outer.getBoundingClientRect().height || header_outer.offsetHeight || 0);
		const spacerHeight = Math.ceil(stickyTarget.getBoundingClientRect().height || stickyTarget.offsetHeight || headerHeight);

		if (headerHeight > 0) {
			html_tag.style.setProperty('--sticky_offset_m', `${headerHeight}px`);
			html_tag.style.setProperty('--header_mih_c', `${headerHeight}px`);
			html_tag.style.setProperty('--header_height_static', `${headerHeight}px`);
		}

		if (header_inner.classList.contains('mobile-visible-search')) {
			top_id.classList.add('has-mobile-visible-search');
			html_tag.classList.add('has-mobile-visible-search');
		}

		if (spacerHeight <= 0 || document.getElementById('distance-spacer')) return;

		const spacer = document.createElement('div');
		spacer.id = 'distance-spacer';
		spacer.style.height = `${spacerHeight}px`;
		stickyTarget.after(spacer);
	});
}

primeMobileProductHeaderSpacing();

window.addEventListener('load', primeMobileProductHeaderSpacing, asyncOnce);
window.addEventListener('pageshow', primeMobileProductHeaderSpacing, asyncOnce);
window.addEventListener('resize', throttle(() => {
	if (shouldSkipScrollResizeWork()) return;
	primeMobileProductHeaderSpacing();
}, 500));

// Calculates and sets the browser scrollbar width as a CSS variable
let scrollbarWidth = null;

function getScrollbarWidth(forceRecalc = false) {
	if (forceRecalc) {
		scrollbarWidth = null;
	}
	if (scrollbarWidth !== null) return scrollbarWidth;

	/*const div = document.createElement('div');
	Object.assign(div.style, {
		width: '100px',
		height: '100px',
		overflow: 'scroll',
		position: 'absolute',
		top: '-9999px'
	});
	document.body.appendChild(div);

	scrollbarWidth = div.offsetWidth - div.clientWidth;
	document.body.removeChild(div);*/
	const docWidth = html_tag.clientWidth;

	scrollbarWidth = getViewportWidth() - docWidth;

	if (scrollbarWidth < 0) {
		scrollbarWidth = 0;
	}

	html_tag.style.setProperty('--scrollbar_width', scrollbarWidth + 'px');
	return scrollbarWidth;
}

if (mediaMin1000.matches) {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			runWhenIdle(getScrollbarWidth);
		});
	} else {
		runWhenIdle(getScrollbarWidth);
	}
}
if (isShopifyDesignMode()) {
	window.addEventListener('resize', () => {
		if (shouldSkipScrollResizeWork()) return;
		runWhenIdle(() => getScrollbarWidth(true));
	});
}


// Checks the #header-inner element and adds classes to <html> based on its state, e.g., for mobile search visibility or specific header type styling.
if (header_inner) {
	if (header_inner.classList.contains('mobile-visible-search')) {
		html_tag.classList.add('has-mobile-visible-search');
	}

	if (header_inner.classList.contains('t1nn')) {
		html_tag.classList.add('t1nn');
	}
}


// On window resize (throttled), adjusts custom dropdown height and updates CSS variable for static header height.
window.addEventListener('resize', throttle(() => {
	if (shouldSkipScrollResizeWork()) return;
	customDropHeight();

	if (!header_outer || !header_inner) return;

	requestAnimationFrame(() => {
		const headerHeight = header_outer.getBoundingClientRect().height + 'px';
		html_tag.style.setProperty('--header_height_static', headerHeight);
	});
}, 500));


// Updates CSS custom properties with the current heights of the header and top navigation if certain header elements exist.
function customDropHeight() {
	if (!nav_main) return;

	const HH_req = ['.m6fr.wide-transparent', '.m6fr.size-xl', '.m6fr article.size-xl'];
	const hasHH = HH_req.some(selector => document.querySelector(selector));
	if (!hasHH) return;

	requestAnimationFrame(function () {
		if (header_outer && header_inner) {
			const headerHeight = header_outer.getBoundingClientRect().height + 'px';
			html_tag.style.setProperty('--header_height_static', headerHeight);
		}
		if (nav_top_id) {
			const nav_top_idHeight = nav_top_id.getBoundingClientRect().height + 'px';
			html_tag.style.setProperty('--nav_top_h', nav_top_idHeight);
		}
	});
}


// Ensures customDropHeight runs after the logo image is loaded, or immediately if the image is missing or already loaded, so header heights are calculated correctly.
let logo_id = document.querySelector('#logo');
let logo_img = null;
if (logo_id) {
	logo_img = logo_id.querySelector('img') || null;
}

if (logo_img) {
	if (logo_img.complete) {
		customDropHeight();
	} else {
		logo_img.addEventListener('load', customDropHeight);
	}
} else {
	customDropHeight();
}


// Enables breadcrumb "back" functionality if referrer is same site, otherwise removes the element
const breadcrumb_back = document.querySelectorAll('.breadcrumb-back');
if (breadcrumb_back) {
	for (const el of breadcrumb_back) {
		if (document.referrer.includes(window.location.host)) {
			el.addEventListener('click', e => {
				e.preventDefault();
				history.back();
			});
		} else {
			el.remove();
		}
	}
}


// Adds alignment classes to content if elements with .align-middle or .align-center are alone within their parent/grandparent
const alignMiddleElements = document.getElementsByClassName('align-middle');
const alignCenterElements = document.getElementsByClassName('align-center');

function checkAndAddClass(elements, className) {
	for (const el of elements) {
		const parent = el.parentNode;
		const grandparent = parent ? parent.parentNode : null;

		const isCenterElement = (
			(el.previousElementSibling === null && el.nextElementSibling === null && parent.id === 'content') ||
			(el.previousElementSibling === null && el.nextElementSibling === null && parent.previousElementSibling === null && parent.nextElementSibling === null && grandparent.id === 'content')
		);

		if (isCenterElement) {
			content_id.classList.add(className);
		}
	}
}

checkAndAddClass(alignMiddleElements, 'align-center');
checkAndAddClass(alignCenterElements, 'align-center-static');


// .l4ft .content.box - adds 'has-content-box' class to the closest <li> of each '.l4ft .content.box' element if :has() selector is not supported
if (!isHasSelectorSupported()) {
	const list_featured_content_box = document.querySelectorAll('.l4ft .content.box');
	for (const el of list_featured_content_box) {
		let closestLi = el.closest('li');
		if (closestLi) {
			closestLi.classList.add('has-content-box');
		}
	}
}


// Scrolls to a previously clicked "load more" item after page load, centering it and using manual scroll restoration
function scrollToTargetAdjusted(el) {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	el.scrollIntoView({
		block: 'center'
	});
}

const loadMoreItemClicked = localStorage.getItem('loadMoreItemClicked');
if (loadMoreItemClicked) {
	const loadMoreSelectors = [
        `#collection > li > figure > a[href="${loadMoreItemClicked}"]`,
        `.m6cl .results > div a[href="${loadMoreItemClicked}"]`,
        `.m6cl .results > .l4ne a[href="${loadMoreItemClicked}"]`
    ];

	const loadMoreTarget = document.querySelector(loadMoreSelectors.join(', '));
	const loadMoreURL = window.location.href;

	if (loadMoreTarget && !loadMoreURL.includes(loadMoreItemClicked)) {
		scrollToTargetAdjusted(loadMoreTarget);
	}

	localStorage.removeItem('loadMoreItemClicked');
}




/*! Custom Events -------------------------------------------------- */
let ajaxCartEvt = new CustomEvent('ajaxCart');
let searchClassesEvt = new CustomEvent('searchClasses');
let inputPaddingEvt = new CustomEvent('inputPadding');


// Sets header transparency and HTML classes based on first content section type, width, and announcement bar presence.
const transparentHeaderEvt = new CustomEvent('transparentHeaderAsync');
window.addEventListener('transparentHeaderAsync', function () {

	if (!content_id || !header_inner) return;

	const ffa = content_id.children[0];
	let ffc;
	let ffd = false;
	let ffe = false;


	if (ffa) {
		ffc = ffa.children[0];
		if (ffa.classList.contains('shopify-section') && header_inner.hasAttribute('data-transparent')) {
			ffd = true;
		}

		if (ffc && (ffc.classList.contains('m6bx') || ffc.classList.contains('m6fr')) && ffc.classList.contains('wide')) {
			ffe = true;
			ffc.classList.add('im-tr');
		}
		if (ffd) {
			const announcementBar = document.querySelector('.shopify-section-header ~ [class*="shopify-section-announcement-bar"]');
			if (announcementBar) ffd = false;
		}
		if (ffd && ffe && ffc && ffc.classList.contains('wide-transparent')) {
			top_id.classList.add('transparent');
			html_tag.classList.add('has-first-m6fr-wide');
			if (ffc.classList.contains('m6bx')) html_tag.classList.add('has-first-m6bx-wide');

			const hasFlexible = ffc.classList.contains('flexible-section');
			html_tag.classList.toggle('has-first-flexbile-wide', hasFlexible);

			ffc.classList.add('is-first-m6fr-wide');

			const slides = ffa.querySelectorAll('.swiper-slide-active article');
			const firstSlide = slides.length > 0 ? slides[0] : ffa.querySelector('article');

			const fallbackEl = ffa.querySelector('.m6fr');
			const palette = (firstSlide && firstSlide.getAttribute('data-color-palette')) || (fallbackEl && fallbackEl.getAttribute('data-active-content-desktop'));

			if (palette) {
				setTimeout(function () {
					const base = palette.replace('_gradient', '');

					html_tag.style.setProperty('--transparent_header_fg', `var(--${base}_fg)`);
					html_tag.style.setProperty('--transparent_header_bg', `var(--${palette}_bg)`);
					html_tag.style.setProperty('--transparent_header_btn_bg', `var(--${base}_btn_bg)`);
					html_tag.style.setProperty('--transparent_header_btn_fg', `var(--${base}_btn_fg)`);

					const bd = (palette.includes('white') || palette.includes('light')) ? 'var(--header_border_color_light)' : 'var(--header_border_color_dark)';

					html_tag.style.setProperty('--transparent_header_bd', bd);
				}, 0);
			}
		} else {
			header_inner.classList.remove('transparent');
			html_tag.classList.remove('has-first-m6fr-wide', 'has-first-m6bx-wide');
		}
	}
});
window.dispatchEvent(transparentHeaderEvt);


// Handles top header initialization: logo setup, nav alignment, responsive adjustments, search bar and compact modes, and accessible mode toggling
const topEvt = new CustomEvent('top');
window.addEventListener('top', function (event) {
	// Handles logo: adds classes for text spans and shows alt text if image fails to load
	function checkIfImageExists(url, callback) {
		const img = new Image();
		img.onload = () => callback(true);
		img.onerror = () => callback(false);
		img.src = url;
	}

	if (logo_id) {
		const logo_text = logo_id.querySelectorAll('span');

		if (logo_id.parentElement && logo_id.parentElement.classList.contains('text-center-logo') && header_inner && !header_inner.classList.contains('hide-btn')) {
			if (search_id) search_id.classList.add('compact');
		}

		if (logo_text.length && header_inner) {
			header_inner.classList.add('logo-text');
		}

		const imgWithAlt = logo_id.querySelector('img[alt]');

		if (imgWithAlt) {
			const pt = imgWithAlt.parentNode;

			checkIfImageExists(imgWithAlt.src, exists => {
				if (!exists) {
					requestAnimationFrame(() => {
						const span = document.createElement('span');
						span.innerHTML = imgWithAlt.alt;
						pt.appendChild(span);
						pt.classList.add('broken-img');
					});
				}
			});
		}
	}

	// Calculates and sets the CSS variable for logo offset in a centered header layout, throttled via requestAnimationFrame. 
	let calcLogoOffsetScheduled = false;

	function calcLogoOffset() {
		if (calcLogoOffsetScheduled) return;
		calcLogoOffsetScheduled = true;
		requestAnimationFrame(() => {
			if (header_id && logo_id && header_inner.classList.contains('text-center-logo')) {
				const header_width = header_id.getBoundingClientRect().width;
				const offsetPercent = (logo_id.offsetLeft / header_width) * 100 + '%';
				html_tag.style.setProperty('--logo_offset', offsetPercent);
			}
			calcLogoOffsetScheduled = false;
		});
	}

	// Assign classes to top_id based on classes assigned to nav elements
	if (nav_id && nav_id.classList.contains('no-wide')) {
		top_id.classList.add('has-no-wide');
	}

	if (nav_bar_id && nav_bar_id.classList.contains('no-wide')) {
		top_id.classList.add('has-no-wide');
	}


	// Adds or removes the 'inv' class based on element's horizontal position relative to the viewport and a given ratio
	function checkInv(el, ratio) {
		requestAnimationFrame(() => {
			const el_rect = el.getBoundingClientRect();
			const liveViewportWidth = getViewportWidth();
			const el_off = global_dir[1] === false ?
				liveViewportWidth - el_rect.left - el.offsetWidth :
				el_rect.left;

			if (el_off > liveViewportWidth * ratio) {
				el.classList.add('inv');
			} else {
				el.classList.remove('inv');
			}
		});
	}


	// Checks if a nav item fits in the navigation width and hides it if there's not enough space
	function countNavDist(el, em, nav) {
		const off_id = 0;
		const dc = el.dataset.copy;
		const show = nav.querySelector(`.show-all li[data-copy="${dc}"]`);

		let shouldHide = false;

		if (el.classList.contains('temp-hidden')) {
			el.classList.remove('temp-hidden');
			if (show) {
				show.classList.remove('temp-hidden');
			}
		}

		const elRect = el.getBoundingClientRect();
		const navRect = nav.getBoundingClientRect();
		const wdth = elRect.width;
		const nwth = navRect.width;

		const off = (global_dir[1] === false) ?
			nwth - el.offsetLeft - wdth - off_id :
			el.offsetLeft - off_id;

		const hcnt = el.parentElement.querySelectorAll('.temp-hidden:not(.show-all)').length;
		const tolr = hcnt > 0 ? 1.2 : 0;
		const buf = 10;

		const calc = off + wdth + wdth + em * tolr + buf;

		if (nwth < calc) {
			shouldHide = true;
		}

		if (shouldHide) {
			el.classList.add('temp-hidden');
			if (show) {
				show.classList.add('temp-hidden');
			}
		} else {
			el.classList.remove('temp-hidden');
			if (show) {
				show.classList.remove('temp-hidden');
			}
		}
	}


	// Adjusts nav text alignment and hides overflowing items depending on available width and viewport size
	function countNavDistF(el, em, en, nav) {
		let mdc = null;
		let resizeAttached = false;

		function calcNav() {
			if (!mediaMin1000.matches) return;

			if (mdc === null) {
				const mdm = Math.abs(parseFloat(getComputedStyle(el).getPropertyValue('margin-right')));
				mdc = ((nav.classList.contains('text-justify') || nav.classList.contains('have-text-justify')) && !isNaN(mdm)) ?
					mdm :
					0;
			}
			const replaceMap = {
				'have-text-center': 'text-center',
				'have-text-justify': 'text-justify',
				'have-text-end': 'text-end',
				'text-center': 'have-text-center',
				'text-justify': 'have-text-justify',
				'text-end': 'have-text-end'
			};

			const replaceTextClass = (original, replacement) => {
				if (nav.classList.contains(original)) {
					nav.classList.remove(original);
					nav.classList.add(replacement);
				}
			};

			if (!(el.clientWidth > nav.clientWidth + mdc)) {
				replaceTextClass('have-text-center', 'text-center');
				replaceTextClass('have-text-justify', 'text-justify');
				replaceTextClass('have-text-end', 'text-end');
			} else {
				replaceTextClass('text-center', 'have-text-center');
				replaceTextClass('text-justify', 'have-text-justify');
				replaceTextClass('text-end', 'have-text-end');

				if (em.length) {
					en = em[0].getBoundingClientRect().width;
				}

				const children = Array.from(el.children);

				const handleResize = () => {
					if (shouldSkipScrollResizeWork()) return;
					requestAnimationFrame(() => {
						children.forEach(eo => {
							countNavDist(eo, en, nav);
						});
					});
				};

				handleResize();

				if (!resizeAttached) {
					window.addEventListener('resize', throttle(handleResize, 100));
					resizeAttached = true;
				}
			}
		}

		calcNav();
		mediaMin1000.addEventListener('change', calcNav);
	}


	// Initializes navigation menus: sets data attributes, handles "show all" submenus, logo loading, responsive adjustments, and inversion checks for submenus.
	let navLayoutInitialized = false;

	function initNavLayouts() {
		if (navLayoutInitialized) return;
		navLayoutInitialized = true;

		const navs = document.querySelectorAll('#nav, #nav-bar');
		if (!navs.length) return;

		if (nav_outer) top_id.classList.add('has-nav-outer');

		navs.forEach(nav_main => {
			if (nav_main.closest('#header-inner')) html_tag.classList.add('has-inside-nav');

			const nmu = nav_main.querySelector('[data-type]');
			const nms = 0;

			if (!nmu) return;

			Array.from(nmu.children).forEach(function (el, index) {
				el.setAttribute('data-copy', nmu.children.length - index);
			});

			const nml = nmu.querySelector('li.show-all');
			if (nml) {
				const all_submenu = createElementWithClass('ul', 'show-all-submenu');
				nml.appendChild(all_submenu);

				for (const el of nml.closest('ul').children) {
					if (!el.classList.contains('show-all')) {
						all_submenu.appendChild(el.cloneNode(true));
					}
				}

				function markReady() {
					top_id?.classList.add('ready');
					header_id?.classList.add('ready');
					header_outer?.classList.add('ready');
				}

				function updateNav() {
					calcLogoOffset();
					countNavDistF(nmu, nml, nms, nav_main);
					markReady();
				}

				function initLogoLoad() {
					if (logo_img) {
						if (logo_img.complete) {
							updateNav();
						} else {
							logo_img.addEventListener('load', updateNav, {
								once: true
							});
						}
					} else {
						updateNav();
					}
				}

				if (nav_outer) {
					calcLogoOffset();
					setTimeout(initLogoLoad, 250);
				} else {
					setTimeout(() => {
						countNavDistF(nmu, nml, nms, nav_main);
						header_outer.classList.add('ready');
					}, 250);
				}

				window.addEventListener('resize', throttle(() => {
					if (shouldSkipScrollResizeWork()) return;
					calcLogoOffset();
					header_outer.classList.remove('ready');
					countNavDistF(nmu, nml, nms, nav_main);
					header_outer.classList.add('ready');
				}, 250));
			}

			function executeCheckInv(nmv) {
				Array.from(nmv).forEach(el => checkInv(el, 0.5));
			}
			const nmv = nav_main.getElementsByClassName('sub-static');
			if (nmv.length) {
				let checkInvExecuted = false;

				function runCheckInv() {
					if (!checkInvExecuted) {
						executeCheckInv(nmv);
						checkInvExecuted = true;
					}
				}

				window.addEventListener('mousemove', runCheckInv);
				window.addEventListener('resize', throttle(() => {
					if (shouldSkipScrollResizeWork()) return;
					checkInvExecuted = false;
					runCheckInv();
				}, 500));
			}

			for (const el of nav_main.querySelectorAll('a[href="#"]:not(.toggle)')) {
				const parent = el.parentElement;
				if (parent) parent.classList.add('empty-url');
			}
		});
	}

	if (isMobileHomeTemplate) {
		scheduleMobileHomeDeferredInit(initNavLayouts, 1200);
		mediaMin1000.addEventListener('change', event => {
			if (event.matches) initNavLayouts();
		});
	} else {
		initNavLayouts();
	}


	// Adjusts top header and search bar classes based on search/header state and viewport width for responsive layout.
	if (search_id && header_inner) {
		// if (!isHasSelectorSupported()) {
		if (search_id.classList.contains('no-bg') && !search_id.classList.contains('bd-b')) {
			top_id.classList.add('no-bd-m');
		}
		if (search_id.classList.contains('no-bg')) {
			top_id.classList.add('no-bd');
		}
		if (search_id.classList.contains('no-pd-t')) {
			top_id.classList.add('no-pd-t');
		}
		// }
		if (!search_id.classList.contains('compact') && header_inner.classList.contains('hide-btn') && header_inner.classList.contains('text-center-logo')) {
			search_id.classList.add('not-compact');
			if (search_id.classList.contains('not-compact')) {
				function updateSearch() {
					if (mediaMax1000.matches) {
						search_id.classList.add('compact');
					} else if (mediaMin1000.matches) {
						search_id.classList.remove('compact');
					}
				}

				updateSearch();

				mediaMax1000.addEventListener('change', updateSearch);
				mediaMin1000.addEventListener('change', updateSearch);
			}
		}
	}


	// Syncs <html> classes with search_id state: adds/removes classes for compact modes and centered sticky layout.
	if (search_id) {
		if (search_id.classList.contains('compact-handle')) {
			html_tag.classList.add('t1sh-mobile', 'search-compact-handle');
		} else {
			html_tag.classList.remove('t1sh-mobile', 'search-compact-handle');
		}

		if (search_id.classList.contains('compact-handle-mobile')) {
			html_tag.classList.add('t1sh-mobile', 'search-compact-handle', 'search-compact-handle-mobile');
		} else {
			html_tag.classList.remove('search-compact-handle-mobile');
		}

		if (search_id.classList.contains('compact')) {
			if (search_id.classList.contains('compact-handle')) {
				html_tag.classList.add('t1sh');
			} else {
				html_tag.classList.remove('t1sh');
			}
			html_tag.classList.add('t1sr');
		} else {
			html_tag.classList.remove('t1sr', 't1sh');
		}

		html_tag.classList.toggle('search-compact-is-centered', search_id.classList.contains('text-center-sticky'));
	}


	// Toggles accessible mode on/off, updates CSS, and stores preference in a cookie
	const accessible_css = fp('styles/theme-accessible.css', 'theme_accessible_css');
	const a_accessible = document.getElementsByClassName('link-accessible');

	function accessibleLink(el) {
		const isActive = html_tag.classList.contains('t1ac');

		if (isActive) {
			html_tag.classList.remove('t1ac');
			Cookies.set('accessible', 'no');
		} else {
			new_css('accessible-mode-css', accessible_css);
			html_tag.classList.add('t1ac');
			Cookies.set('accessible', 'yes');
		}

		if (nav_id || nav_bar_id) {
			const tempHidden = nav_main.getElementsByClassName('temp-hidden');
			setTimeout(() => {
				for (const el of tempHidden) {
					el.classList.remove('temp-hidden');
				}
				window.dispatchEvent(new Event('resize'));
			}, 100);
		}
	}

	if (a_accessible.length) {
		for (const el of a_accessible) {
			const parent = el.parentElement;
			if (parent && !parent.classList.contains('has-link-accessible')) {
				parent.classList.add('has-link-accessible');
			}
		}

		html_tag.addEventListener('click', event => {
			const link = event.target.closest('a.link-accessible');
			if (link) {
				accessibleLink(link);
				event.preventDefault();
			}
		});
		html_tag.addEventListener('keyup', event => {
			if (event.key === ' ' || event.key === 'Enter') {
				const link = event.target.closest('a.link-accessible');
				if (link) {
					accessibleLink(link);
					event.preventDefault();
				}
			}
		});
	}

	if (Cookies.get('accessible') === 'yes') {
		new_css('accessible-mode-css', accessible_css);
		html_tag.classList.add('t1ac');
	} else {
		html_tag.classList.remove('t1ac');
		Cookies.remove('accessible');
	}
});
window.dispatchEvent(topEvt);


// #background - moves the background element to #root and marks it as done when the custom 'background' event is triggered
const backgroundEvt = new CustomEvent('background');
window.addEventListener('background', function (event) {
	const bg_done = document.querySelector('#background.done');
	if (bg_done) {
		bg_done.remove();
	}
	const bg_id = document.getElementById('background');
	if (bg_id && !bg_id.classList.contains('static') && (bg_id.parentNode.id === 'content' || bg_id.parentNode.classList.contains('shopify-section'))) {
		const root = document.getElementById('root') || document.body;
		if (root) {
			root.appendChild(bg_id);
			bg_id.classList.add('done');
		}
	}
});
window.dispatchEvent(backgroundEvt);


// Enhancement modules moved to assets/custom-enhancements.js (lazy-loaded).


// Applies/removes skeleton placeholders for collection cards and cart items as images hydrate.
function initImageSkeletons(scope) {
	const root = scope && scope.querySelector ? scope : document;
	const skeletonItems = [];
	if (root instanceof Element && root.matches('.skeleton-pending')) {
		skeletonItems.push(root);
	}
	if (root.querySelectorAll) {
		skeletonItems.push(...root.querySelectorAll('.skeleton-pending'));
	}
	if (!skeletonItems.length) return;

	const markReady = (item) => {
		item.classList.remove('skeleton-pending');
		item.classList.add('skeleton-ready');
		item.removeAttribute('data-skeleton-bound');
	};

	for (const item of skeletonItems) {
		const img = item.querySelector('figure img, img');
		if (!img) {
			markReady(item);
			continue;
		}

		if (img.complete) {
			markReady(item);
			continue;
		}

		if (item.getAttribute('data-skeleton-bound') === '1') continue;
		item.setAttribute('data-skeleton-bound', '1');

		const onDone = () => markReady(item);
		img.addEventListener('load', onDone, { once: true });
		img.addEventListener('error', onDone, { once: true });
	}
}

initImageSkeletons(document);
window.addEventListener('load', () => initImageSkeletons(document), asyncOnce);
document.addEventListener('shopify:section:load', (event) => {
	initImageSkeletons(event && event.target ? event.target : document);
});

function initMainProductTitleSkeleton(scope) {
	const root = scope && scope.querySelector ? scope : document;
	const headers = root.querySelectorAll('#main-product header.skeleton-pending-title');
	if (!headers.length) return;

	const firstMediaImage = document.querySelector('#main-product .pdp-gallery__item img, #main-product .l4pr li img');
	if (!firstMediaImage) {
		headers.forEach((header) => header.classList.remove('skeleton-pending-title'));
		return;
	}

	const clearHeaders = () => {
		headers.forEach((header) => header.classList.remove('skeleton-pending-title'));
	};

	if (firstMediaImage.complete) {
		clearHeaders();
		return;
	}

	firstMediaImage.addEventListener('load', clearHeaders, { once: true });
	firstMediaImage.addEventListener('error', clearHeaders, { once: true });
}

initMainProductTitleSkeleton(document);
window.addEventListener('load', () => initMainProductTitleSkeleton(document), asyncOnce);
document.addEventListener('shopify:section:load', (event) => {
	initMainProductTitleSkeleton(event && event.target ? event.target : document);
});

if (!window.__imageSkeletonObserverInstalled) {
	window.__imageSkeletonObserverInstalled = true;
	const imageSkeletonObserver = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
				for (const node of mutation.addedNodes) {
					if (!(node instanceof Element)) continue;
						if (node.matches('.skeleton-pending') || node.querySelector('.skeleton-pending')) {
							initImageSkeletons(node);
						}
						if (node.matches('#main-product, .m6pr, .skeleton-pending-title') || node.querySelector('#main-product header.skeleton-pending-title')) {
							initMainProductTitleSkeleton(node);
						}
					}
			}
		});
	imageSkeletonObserver.observe(document.documentElement, { childList: true, subtree: true });
}





/*! Async Resources & Touch Interaction -------------------------------------------------- */

// Loads async CSS and JS resources on first user interaction, including hover-fix on hybrid devices that falsely report no hover
const outline_js = fp('js/plugin-outline.js', 'plugin_outline_js');
const css_async = fp('styles/async.css', 'async_css');
const css_menu = fp('styles/async-menu.css', 'async_menu_css');
const css_hovers = fp('styles/async-hovers.css', 'async_hovers_css');
const css_hovers_hack = fp('styles/async-hovers-hack.css', 'async_hovers_hack_css');
const validation_css = fp('styles/async-validation.css', 'async_validation_css');
const isFakeNoHover = navigator.maxTouchPoints > 0 && window.matchMedia('(pointer: fine)').matches && !window.matchMedia('(hover: hover)').matches;

let asyncCSSLoaded = false;

function asyncCSS() {
	if (asyncCSSLoaded) return;

	new_css('async-css', css_async);
	new_css('hovers-css', css_hovers);

	if (isFakeNoHover) {
		new_css('hovers-hack-css', css_hovers_hack);
	}

	new_css('menu-css', css_menu);
	loadRes(outline_js, () => {}, 'outline-loaded');

	asyncCSSLoaded = true;

	const skip_id = document.getElementById('skip');
	if (skip_id && nav_bar_id) {
		const link = skip_id.querySelector('a[href="#nav"]');
		if (link) {
			link.setAttribute('href', '#nav-bar');
		}
	}
}

window.addEventListener('mousemove', asyncCSS, asyncOnce);
document.addEventListener('keyup', asyncCSS, asyncOnce);
document.addEventListener('touchstart', asyncCSS, asyncPass);
document.addEventListener('pointerdown', asyncCSS, asyncPass);
window.addEventListener('wheel', asyncCSS, asyncPass);
if (!isMobile) {
	window.addEventListener('load', () => {
		setTimeout(() => {
			runWhenIdle(asyncCSS);
		}, 1200);
	}, asyncOnce);
}


// Adds and removes a .touch-moving class on the <html> element to indicate when the user is actively touching or scrolling on a touchscreen device.
let touchMoving = false;
let lastScrollY = 0;
let scrollCheckTimeout;

window.addEventListener('touchstart', () => {
	clearTimeout(scrollCheckTimeout);
	touchMoving = true;
	html_tag.classList.add('touch-moving');
});

window.addEventListener('touchend', () => {
	const checkScrollEnd = () => {
		const currentY = window.scrollY;
		if (Math.abs(currentY - lastScrollY) < 2) {
			touchMoving = false;
			html_tag.classList.remove('touch-moving');
		} else {
			lastScrollY = currentY;
			scrollCheckTimeout = setTimeout(checkScrollEnd, 100);
		}
	};
	lastScrollY = window.scrollY;
	scrollCheckTimeout = setTimeout(checkScrollEnd, 100);
});


// Loads less crucial JavaScript
const custom_async_js = fp('js/custom-async.js', 'custom_async_js');
const navBootstrapSelector = 'a.toggle-wide, #header [aria-controls="nav"], a[href="#nav"], a[href="#nav-bar"]';

const ensureCustomAsync = (callback) => {
	loadRes(custom_async_js, () => {
		if (typeof callback === 'function') callback();
	}, 'custom-async-loaded');
};

const loadCustomAsync = () => {
	ensureCustomAsync();
};

if (!isMobile) {
	window.addEventListener('mousemove', loadCustomAsync, asyncOnce);
}
window.addEventListener('pointerdown', loadCustomAsync, asyncPass);
window.addEventListener('wheel', loadCustomAsync, asyncPass);
document.addEventListener('keyup', loadCustomAsync, asyncOnce);
document.addEventListener('touchstart', loadCustomAsync, asyncPass);
if (!isMobile) {
	window.addEventListener('load', () => {
		setTimeout(() => {
			runWhenIdle(loadCustomAsync);
		}, 2000);
	}, asyncOnce);
}

// Ensure the mobile menu opens on first tap even before custom-async.js has booted.
document.addEventListener('click', (event) => {
	if (html_tag.classList.contains('custom-async-loaded')) return;

	const trigger = event.target && event.target.closest ? event.target.closest(navBootstrapSelector) : null;
	if (!trigger) return;

	event.preventDefault();
	event.stopPropagation();

	ensureCustomAsync(() => {
		if (!trigger.isConnected) return;
		trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
	});
}, true);
